import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Pole praegu saadaval

  <span style="color:#85c1dc;">**FI:**</span>
  Ei ole saatavilla tehdyillä vaihtoehdoilla

  <span style="color:#85c1dc;">**RU:**</span>
  В настоящее время недоступно
*/
/* @__NO_SIDE_EFFECTS__ */
const m1253 = msg(
  mf`Pole praegu saadaval`,
  mf`Ei ole saatavilla tehdyillä vaihtoehdoilla`,
  mf`В настоящее время недоступно`,
)

export { m1253 as 'w.global.product_option.not_available' }